import { useState } from 'react';
import { useForm, UseFormMethods } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { apiFetch } from 'services/apiFetch';
import yup from 'utils/yup';

type UseFormType = Partial<Pick<UseFormMethods, 'register' | 'errors'>> & {
  onSubmit: () => void,
  loading: boolean,
};

type Props = {
  token: string,
  setShowSuccessDialog: React.Dispatch<React.SetStateAction<boolean>>,
  setShowErrorDialog: React.Dispatch<React.SetStateAction<boolean>>,
};

const schema = yup.object().shape({
  password: yup.string().required().label('Senha'),
  passwordConfirmation: yup.string()
    .oneOf([yup.ref('password'), null], 'As senhas não coincidem.').label('Confirmar senha'),
});

export default ({
  token, setShowSuccessDialog, setShowErrorDialog,
}: Props):UseFormType => {
  const [loading, setLoading] = useState(false);

  const {
    register, handleSubmit, errors,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit(async (formData) => {
    setLoading(true);

    try {
      const response = await apiFetch('/password', {
        method: 'PATCH',
        body: JSON.stringify({
          token,
          password: formData.password,
          password_confirmation: formData.passwordConfirmation,
        }),
      });

      if (response.ok) {
        setShowSuccessDialog(true);
      } else {
        setShowErrorDialog(true);
      }
    } catch {
      setShowErrorDialog(true);
    }

    setLoading(false);
  });

  return {
    register,
    errors,
    onSubmit,
    loading,
  };
};
